<template>
    <div class="qty-stepper">
        <button class="btn btn-sm btn-outline-secondary" type="button" @click="change(-1)" :disabled="modelValue <= min">−</button>
        <input type="number" class="qty-stepper__input" :min="min" :value="modelValue" @change="onInput" />
        <button class="btn btn-sm btn-outline-secondary" type="button" @click="change(1)">+</button>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({
    emits: ['update:modelValue']
})
export default class QuantityStepper extends Vue {

    @Prop({ default: 0 }) modelValue: number;
    @Prop({ default: 0 }) min: number;

    change(delta: number) {
        const newValue = Math.max(this.min, this.modelValue + delta);
        this.$emit('update:modelValue', newValue);
    }

    onInput(event: Event) {
        const value = parseInt((event.target as HTMLInputElement).value, 10);
        const newValue = isNaN(value) ? this.min : Math.max(this.min, value);
        this.$emit('update:modelValue', newValue);
    }
}
</script>

<style scoped>
.qty-stepper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
}
.qty-stepper__input {
    width: 58px;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    color: #015454;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 2px 4px;
}
.qty-stepper__input::-webkit-inner-spin-button,
.qty-stepper__input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>
